import { createContext, useContext, useState } from "react";

interface IDefaultValues {
  setAudio: any;
  getAudio: any;
}

function defaultValue(): IDefaultValues {
  const setAudio = null;
  const getAudio = null;

  return { setAudio, getAudio };
}

export const AudioContext = createContext(defaultValue());
export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context && typeof window !== 'undefined') {
    throw new Error(`useAudio must be used within a AudioContext `);
  }
  return context;
};

export const AudioProvider = ({ children }) => {
  const [ audioRef, _setAudio ] = useState(null);

  const setAudio = (newAudioRef) => {
    _setAudio(newAudioRef);
  }
  const getAudio = audioRef;

  return <AudioContext.Provider value={{ setAudio, getAudio }}>{children}</AudioContext.Provider>
}